import { isWeb } from "@tamagui/constants";
import { getAllSelectors } from "./insertStyleRule";
import { names, normalizeColor } from "./normalizeColor";
import { normalizeStylePropKeys } from "./normalizeStylePropKeys";
const colorCache = /* @__PURE__ */ new Map();
function normalizeValueWithProperty(value, property) {
  if (property && property in unitlessNumbers) {
    return value;
  }
  let res = value;
  if (property && (property in normalizeStylePropKeys || value in names)) {
    if (colorCache.has(value)) {
      return colorCache.get(value);
    }
    res = normalizeColor(value);
    if (colorCache.size > 1e3) {
      colorCache.clear();
    }
    colorCache.set(value, res);
  } else if (isWeb && typeof value === "number" && (property === void 0 || !(property in unitlessNumbers || property in stringNumbers))) {
    res = `${value}px`;
  } else if (isWeb && property !== void 0 && property in stringNumbers) {
    res = `${res}`;
  }
  return res;
}
const stringNumbers = {
  zIndex: true
};
const unitlessNumbers = {
  WebkitLineClamp: true,
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowGap: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnGap: true,
  gridColumnStart: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zoom: true,
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  shadowOpacity: true
};
const rcache = {};
function reverseMapClassNameToValue(key, className) {
  const selectors = getAllSelectors();
  const cssRule = selectors[className];
  if (rcache[cssRule]) {
    return rcache[cssRule];
  }
  if (!cssRule) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        `No CSS rule found for ${key} looking for selector ".${className}", you may not be injecting extracted CSS`
      );
    }
    return;
  }
  const cssVal = cssRule.replace(/.*:/, "").replace(/;.*/, "").trim();
  let res;
  if (cssVal.startsWith("var(")) {
    res = cssVal;
  } else if (unitlessNumbers[key]) {
    res = +cssVal;
  } else if (cssVal.endsWith("px")) {
    res = +cssVal.replace("px", "");
  } else {
    res = cssVal;
  }
  rcache[cssRule] = res;
  if (process.env.NODE_ENV === "development") {
    if (typeof res === "number" && isNaN(res)) {
      console.log("Tamagui invalid parsed value, NaN:", {
        res,
        cssVal,
        cssRule,
        key,
        className
      });
    }
  }
  return res;
}
export {
  normalizeValueWithProperty,
  reverseMapClassNameToValue
};
//# sourceMappingURL=normalizeValueWithProperty.js.map
